import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

const AuthWrapper = ({ children }) => {
  const navigate = useNavigate();
  const [isSessionExpired, setIsSessionExpired] = useState(false);

  useEffect(() => {
    const checkAuth = () => {
      const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
      const sessionExpiration = localStorage.getItem("sessionExpiration");
      const currentTime = Date.now();

      if (
        !isLoggedIn ||
        !sessionExpiration ||
        currentTime > parseInt(sessionExpiration)
      ) {
        if (
          isLoggedIn &&
          sessionExpiration &&
          currentTime > parseInt(sessionExpiration)
        ) {
          setIsSessionExpired(true);
        } else {
          navigate("/login");
        }
      }
    };

    checkAuth();

    const interval = setInterval(checkAuth, 60000);

    return () => clearInterval(interval);
  }, [navigate]);

  useEffect(() => {
    if (isSessionExpired) {
      let timerInterval;
      MySwal.fire({
        title: "Session Expired",
        html: (
          <div className="text-gray-600">
            Your session has expired. Please extend or you will be redirected to
            login in <strong id="timer">20</strong> seconds.
          </div>
        ),
        timer: 20000,
        timerProgressBar: true,
        showConfirmButton: true,
        confirmButtonText: "Extend Session",
        confirmButtonColor: "#dc2626", // Matches the red-600 from LoginForm
        showCancelButton: true,
        cancelButtonText: "Logout",
        cancelButtonColor: "#6b7280", // Gray-500 for contrast
        customClass: {
          popup: "rounded-lg shadow-xl",
          title: "text-2xl font-semibold text-gray-900",
          htmlContainer: "text-sm",
          confirmButton: "px-4 py-2 rounded-md text-white font-medium",
          cancelButton: "px-4 py-2 rounded-md text-white font-medium",
          timerProgressBar: "bg-red-600",
        },
        didOpen: () => {
          const timer = MySwal.getHtmlContainer().querySelector("#timer");
          timerInterval = setInterval(() => {
            const timeLeft = Math.ceil(MySwal.getTimerLeft() / 1000);
            timer.textContent = timeLeft;
          }, 1000);
        },
        willClose: () => {
          clearInterval(timerInterval);
        },
      }).then((result) => {
        if (result.isConfirmed) {
          // Extend session by 3 hours
          const newExpirationTime = Date.now() + 3 * 60 * 60 * 1000;
          localStorage.setItem(
            "sessionExpiration",
            newExpirationTime.toString()
          );
          setIsSessionExpired(false);
        } else {
          localStorage.removeItem("isLoggedIn");
          localStorage.removeItem("sessionExpiration");
          navigate("/login");
        }
      });
    }
  }, [isSessionExpired, navigate]);

  return <div>{children}</div>;
};

export default AuthWrapper;
